import React, { useState, useEffect, useRef } from 'react';
import styles from './OddsButton.module.scss';
import { MINIMUM_ODD_VALUE, ODDS_BUTTON_TYPES } from '../../../constants/defaultValues';
import { renderOdd } from '../../../utils/render';

const OddsButton = props => {
    const {
        marketStatus,
        outcomeStatus,
        odd,
        changeType,
        isNull,
        selected,
        type,
        isFrozen,
        isClosed,
        addToSlip,
        removeFromSlip,
    } = props;

    const isEmpty = isNull || isFrozen || isClosed || odd < MINIMUM_ODD_VALUE;

    const [increased, setIncreased] = useState(false);
    const [decreased, setDecreased] = useState(false);
    const timeout = useRef();

    useEffect(() => {
        if (isEmpty || !changeType) {
            setDecreased(false);
            setIncreased(false);
            return;
        }

        if (changeType === 'increase') {
            setIncreased(true);
            setDecreased(false);
        } else if (changeType === 'decrease') {
            setDecreased(true);
            setIncreased(false);
        }

        timeout.current = setTimeout(() => {
            setDecreased(false);
            setIncreased(false);
        }, 5000);
    }, [odd, changeType, isEmpty]);

    useEffect(() => {
        return () => {
            if (timeout.current) {
                clearTimeout(timeout.current);
            }
        };
    }, []);

    const renderOddContent = () => {
        let oddContent;

        if (type === ODDS_BUTTON_TYPES.long) {
            oddContent = <div className={styles.long}>{props.children}</div>;
        } else {
            oddContent = renderOdd({ odd, marketStatus, outcomeStatus, isNull, isFrozen });
        }

        return oddContent;
    };

    const onClick = () => {
        if (selected) {
            removeFromSlip();
        } else {
            addToSlip();
        }
    };

    return (
        <button
            className={`${styles.oddsButton}
                ${selected ? styles.selected : ''}
                ${isNull ? styles.null : ''} 
                ${increased ? styles.increased : ''}
                ${decreased ? styles.decreased : ''}
                `}
            disabled={!selected && isEmpty}
            onClick={onClick}
        >
            {renderOddContent()}
        </button>
    );
};

export default OddsButton;
